import React from 'react';
import ReactDOM from 'react-dom';
import './registerLogger';
import './index.css';
import App from './containers/App';
// import registerServiceWorker from './registerServiceWorker';

// changes during development may cause an issue with the service worker in
// your browser in which case you can import and call unregister to clear cached data
// import { unregister } from './registerServiceWorker';
// unregister();

ReactDOM.render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js